/**
 * Utility functions for converting stroke styles to SVG properties
 */

export type StrokeStyle = 'solid' | 'dashed' | 'dotted';

/**
 * Convert stroke style to SVG strokeDasharray
 * @param style - The stroke style
 * @param strokeWidth - The stroke width for scaling dash patterns
 * @returns SVG strokeDasharray value or undefined for solid
 */
export function getStrokeDashArray(
  style: StrokeStyle,
  strokeWidth: number = 2
): string | undefined {
  switch (style) {
    case 'solid':
      return undefined; // No dash array for solid lines
    case 'dashed':
      // Dash pattern: dash length = 4 * strokeWidth, gap = 3 * strokeWidth
      return `${4 * strokeWidth} ${3 * strokeWidth}`;
    case 'dotted':
      // Dot pattern: dot length = strokeWidth, gap = 2 * strokeWidth
      return `${strokeWidth} ${2 * strokeWidth}`;
    default:
      return undefined;
  }
}

/**
 * Get stroke line cap for different styles
 * @param style - The stroke style
 * @returns SVG strokeLinecap value
 */
export function getStrokeLineCap(
  style: StrokeStyle
): 'round' | 'butt' | 'square' {
  switch (style) {
    case 'dotted':
      return 'round'; // Round caps for dots
    case 'dashed':
    case 'solid':
    default:
      return 'round'; // Round caps for consistent hand-drawn feel
  }
}
